import { useCallback } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { USER_ROLE } from '@/utils/constants'

/**
 * 角色 / 权限辅助 Hook。
 *
 * new-api v1.0.0 起后端按权限表（casbin）鉴权，`/api/user/self` 会返回
 * `permissions.admin_permissions`。存在权限表时以它为准，否则退回角色判断，
 * 这样自定义角色/细化授权也能正确显示按钮。
 */
export function useRole() {
  const user = useAuthStore((state) => state.user)
  const role = user?.role ?? 0
  const permissions = user?.adminPermissions

  const can = useCallback(
    (resource: string, action: string) => {
      if (permissions) return permissions[resource]?.[action] === true
      return role >= USER_ROLE.ADMIN
    },
    [permissions, role]
  )

  const hasAnyAdminPermission = permissions
    ? Object.values(permissions).some((actions) => Object.values(actions).some(Boolean))
    : role >= USER_ROLE.ADMIN

  return {
    role,
    can,
    isUser: role >= USER_ROLE.COMMON,
    isAdmin: hasAnyAdminPermission,
    isRoot: role >= USER_ROLE.ROOT,
  }
}
